import { LogOut } from 'lucide-react'

import type { ReactElement } from 'react'

import { Button } from '@/components/ui/button'
import { useSignOut } from '@/features/auth/api/auth-api'
import { useAuth } from '@/providers/auth-context'

function getInitials(name: string): string {
  const [first = '', ...rest] = name.trim().split(/\s+/).filter(Boolean)
  const last = rest.at(-1) ?? ''
  return (first.charAt(0) + last.charAt(0)).toUpperCase() || '?'
}

export function Header(): ReactElement {
  const { user } = useAuth()
  const signOut = useSignOut()

  return (
    <header className="sticky top-0 z-30 flex h-16 items-center justify-end gap-4 border-b border-border bg-card/60 px-6 backdrop-blur">
      {user && (
        <>
          <div className="flex items-center gap-3">
            <span className="flex h-9 w-9 items-center justify-center rounded-full border border-primary/40 bg-primary/10 text-xs font-semibold text-primary">
              {getInitials(user.name)}
            </span>
            <div className="hidden text-right leading-tight sm:block">
              <p className="text-sm font-medium text-foreground">{user.name}</p>
              <p className="text-xs text-muted-foreground">({user.email})</p>
            </div>
          </div>
          <Button
            variant="ghost"
            size="sm"
            className="h-11 sm:h-9"
            onClick={() => signOut.mutate()}
            disabled={signOut.isPending}
            aria-label="Sair"
          >
            <LogOut className="h-4 w-4" aria-hidden="true" />
            <span className="hidden sm:inline">Sair</span>
          </Button>
        </>
      )}
    </header>
  )
}
